import { Card, Container, Heading, Text, VStack } from "@chakra-ui/react";
import { SocialButtons } from "../../atoms";
import Header from "../../atoms/Header";
import { Footer, SpazioTales } from "../../molecules";
import { useSelector } from "react-redux";
import { getData } from "../../../store/site/selectors";
import DoubleColumn from "../../molecules/DoubleColumn";
import Locandina from "../../molecules/Locandina";

export default function TemporaryHome() {
  const data = useSelector(getData);

  return (
    <>
      <Header />
      wscape
      <Container maxW="6xl" p="50px">
        <DoubleColumn>
          <VStack>
            <Card p="20px">
              <VStack>
                <Heading size="base" fontSize="1.2em">
                  Il sito sarà presto online!
                </Heading>
                <Text fontSize="1.1em" textAlign="center" my="20px">
                  Intanto per qualsiasi info contattaci sui nostri social o via
                  email a
                  <Text as="span" fontWeight="bold">
                    &nbsp;talesmontagnana@gmail.com
                  </Text>
                </Text>
                <SocialButtons />
                <Heading size="base" fontSize="1.2em" mt="20px">
                  Ti aspettiamo il {data}!
                </Heading>
              </VStack>
            </Card>
            <Card
              mt="20px"
              mb="20px"
              p="20px"
              backgroundColor="talesLightYellow.500"
            >
              <VStack>
                <Heading size="base" fontSize="1.2em">
                  Sei un espositore?
                </Heading>
                <Text fontSize="1.1em" textAlign="center" my="20px">
                  Contattaci sui nostri social o via email a
                  <Text as="span" fontWeight="bold">
                    &nbsp;talesmontagnana@gmail.com
                  </Text>
                </Text>
                <SocialButtons />
              </VStack>
            </Card>
          </VStack>
          <Locandina />
        </DoubleColumn>
      </Container>
      <Footer />
    </>
  );
}
